import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b29d5db8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "black heading-main" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "company" }
const _hoisted_4 = { class: "social-media-icons flex ion-align-items-center ion-justify-content-center" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "black heading-main heading-talk ion-text-uppercase" }, " Talks ", -1))
const _hoisted_9 = { class: "black talk-lead" }
const _hoisted_10 = { class: "black" }
const _hoisted_11 = { class: "company" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "black heading-main heading-talk ion-text-uppercase" }, " Profile ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderMain = _resolveComponent("HeaderMain")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderMain, {
        "page-title": "Speaker Profile",
        "default-href": "/speakers"
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("main", null, [
            _createVNode(_component_ion_card, { class: "ion-text-center speaker" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_img, {
                      src: _ctx.speaker.photo,
                      onIonError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.speaker.photo = _ctx.fallbackImage))
                    }, null, 8, ["src"]),
                    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.speaker.first_name) + " " + _toDisplayString(_ctx.speaker.last_name), 1),
                    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.speaker.job_title), 1),
                    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.speaker.organisation), 1),
                    _createElementVNode("div", _hoisted_4, [
                      _withDirectives(_createElementVNode("a", {
                        href: `https://www.twitter.com/${_ctx.speaker.twitter}`,
                        target: "_blank"
                      }, [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: _ctx.logoTwitter,
                          color: "primary"
                        }, null, 8, ["icon"])
                      ], 8, _hoisted_5), [
                        [_vShow, _ctx.speaker.twitter]
                      ]),
                      _withDirectives(_createElementVNode("a", {
                        href: `${_ctx.speaker.linkedin}`,
                        target: "_blank"
                      }, [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: _ctx.logoLinkedin,
                          color: "primary",
                          class: "ion-margin-horizontal"
                        }, null, 8, ["icon"])
                      ], 8, _hoisted_6), [
                        [_vShow, _ctx.speaker.linkedin]
                      ]),
                      _withDirectives(_createElementVNode("a", {
                        href: `${_ctx.speaker.facebook}`,
                        target: "_blank"
                      }, [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: _ctx.logoFacebook,
                          color: "primary"
                        }, null, 8, ["icon"])
                      ], 8, _hoisted_7), [
                        [_vShow, _ctx.speaker.facebook]
                      ])
                    ]),
                    (_ctx.isFavourite)
                      ? (_openBlock(), _createBlock(_component_ion_button, {
                          key: 0,
                          expand: "block",
                          color: "danger",
                          fill: "outline",
                          class: "f-normal ion-margin-top",
                          onClick: _ctx.removeFromFavourite,
                          disabled: _ctx.isLoading
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.isLoading
                    ? 'Removing from Favourites..'
                    : 'Remove from favourites'), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"]))
                      : (_openBlock(), _createBlock(_component_ion_button, {
                          key: 1,
                          expand: "block",
                          color: "danger",
                          fill: "solid",
                          class: "f-normal ion-margin-top",
                          onClick: _ctx.addToFavourite,
                          disabled: _ctx.isLoading
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.isLoading ? 'Adding to Favourites..' : 'Add to favourites'), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.talks)
              ? (_openBlock(), _createBlock(_component_ion_card, {
                  key: 0,
                  class: "talk-card ion-activatable ripple-parent",
                  "router-link": `/agenda/${_ctx.talks.id}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_content, { class: "talk-card-top" }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.talks.name), 1),
                        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.fireBaseTime(_ctx.talks.start_date)) + " - " + _toDisplayString(_ctx.fireBaseTime(_ctx.talks.end_date)), 1),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.room.name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["router-link"]))
              : _createCommentVNode("", true),
            (_ctx.speaker.bio)
              ? (_openBlock(), _createBlock(_component_ion_card, {
                  key: 1,
                  class: "profile-card"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12,
                    _createElementVNode("p", {
                      class: _normalizeClass(["bio ion-text-justify", [{ readMore: _ctx.readMore }]])
                    }, _toDisplayString(_ctx.speaker.bio), 3),
                    _createElementVNode("span", {
                      class: "ion-color-primary read-more-text",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleReadMore && _ctx.handleReadMore(...args)))
                    }, _toDisplayString(_ctx.readMore ? 'Read less' : 'Read more'), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}